export default __webpack_public_path__ + "static/card-syncstage-highly-scalable-0cc4e1e2ac899bec46985505b522977f.png";